'use strict';
import {DatePickerController} from './DatePickerController';
import template from './date-picker.html';

DatePickerDirective.$inject = [
  '$modal',
  '$filter',
  'DeviceServices',
];

export function DatePickerDirective($modal, $filter, DeviceServices) {
  /*if (DeviceServices.isWebView()) {
    return {
      restrict: 'E',
      replace: true,
      priority: 1500,
      template: '<input class="date-input" type="date"/>'
    }
  }*/

  const dateFilter = $filter('date');

  return {
    restrict: 'E',
    require: ['?ngModel'],
    link: function ($scope, $element, $attr, ctrls) {

      // if ngModel is not defined, we don't need to do anything
      const ngModelCtrl = ctrls[0];
      if (!ngModelCtrl) return;

      //console.log('initializing date-picker directive', ngModelCtrl.$viewValue);

      ngModelCtrl.$render = function () {
        //console.log('rendering value for date-picker directive', ngModelCtrl.$viewValue);
        writeValue(ngModelCtrl.$viewValue);
      };

      $element.on('click', _onClick);

      $scope.$on('$destroy', function () {
        $element.off('click', _onClick);
      });

      function writeValue(value) {
        //console.log('writing to DOM value for date-picker directive', value);
        if (!value) {
          $element.text('--/--/--'); // TODO: add support for a pluggable placeholder
        } else {
          $element.text(dateFilter(value, 'shortDate'));
        }
      }

      function _onClick($event) {
        //console.log('clicked date picker', ngModelCtrl.$modelValue, ngModelCtrl.$viewValue)
        $event.preventDefault();
        $modal.show({
          controller: DatePickerController,
          template: template,
          locals: {
            currentValue: ngModelCtrl.$modelValue
          }
        }).then(update);
      }

      function update(value) {
        //console.log('updating model value for date-picker directive', value, ngModelCtrl.$modelValue, ngModelCtrl.$viewValue);
        $scope.$evalAsync(function () {
          ngModelCtrl.$setViewValue(value);
          writeValue(value);
          //console.log('updated model value for date-picker directive', ngModelCtrl.$modelValue, ngModelCtrl.$viewValue)
        });
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/js/core-components/android-date-time-pickers/DatePickerDirective.js